import { render, staticRenderFns } from "./transaction-detail.component.vue?vue&type=template&id=78f9a47e&"
import script from "./transaction-detail.component.vue?vue&type=script&lang=ts&"
export * from "./transaction-detail.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports